import { Typography } from 'antd';

const EmptyCertificate = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <Typography.Paragraph style={{ fontSize: '18px', color: '#8c8c8c' }}>
        No certificates are associated with this product.
      </Typography.Paragraph>
    </div>
  );
};

export default EmptyCertificate;
